const translations = {
    en: {
        events: {
            attractions_cards_slider: {
                rating: "Rating:",
                find_out: "FIND OUT"
            }
        }
    },
    de: {
        events: {
            attractions_cards_slider: {
                rating: "Bewertung:",
                find_out: "AUSFINDEN"
            }
        }
    },
    es: {
        events: {
            attractions_cards_slider: {
                rating: "Puntuación:",
                find_out: "Descubre"
            }
        }
    },
    fr: {
        events: {
            attractions_cards_slider: {
                rating: "ÉVALUATION:",
                find_out: "DÉCOUVREZ"
            }
        }
    },
    it: {
        events: {
            attractions_cards_slider: {
                rating: "Valutazione:",
                find_out: "SCOPRI"
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/events/AttractionsCardsSlider.js